module.exports = __webpack_public_path__ + "img/4.88a245c2.png";